import { log } from "./utils.js";

const STYLE_ID = "hks-stage-widget-shadow-style";
const HOST_SELECTOR = "#stage-widget[data-widget-id]";
const MAX_ATTEMPTS = 120;
const INTERVAL_MS = 500;
const SVG_DATA_URL =
    "data:image/svg+xml;base64,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";

function getStyleMarkup() {
    return `
        .css-zyo6ya {
            position: relative;
            overflow: hidden;
            border: none;
        }

        .css-zyo6ya::after {
            content: "";
            position: absolute;
            inset: 0;
            pointer-events: none;
            background-color: #fff;
            border-radius: 50%;
            background-image: url("${SVG_DATA_URL}");
            background-repeat: no-repeat;
            background-position: center;
            background-size: 85% auto;
            border: none;
            z-index: 2;
        }
        .css-t9rrt7 {
            font-weight: 700;
            }
        .css-1d0o162 {
            border: none;
        }
        .css-6l2s1z {
            gap: .75rem;
            padding: 1.25rem 1rem;
        }
        .css-1d0o162 {
            border-radius: 0;
            padding: 0px;
            cursor: pointer;
            color: rgb(225, 48, 108);
            border: none !important;
        }
        .css-1d0o162:focus-visible {
            outline: 2px solid var(--hks-primary, #003064);
            outline-offset: 2px;
        }
        .css-zw12sa {
            width: 1.5rem;
            height: 1.5rem;

        }
        .css-1d0o162 {
            color: var(--hks-primary);
        }
        .css-yvr4g9 {
            border:none;
            }
        .css-1wuxw35 {
            background-color: rgb(216.75, 223.95, 231.75);
        }
        .css-89zx61 {
            padding: 1.5rem;
        }
        .css-18s6wo4 {
            --hks-btn-padding-y: 0.75rem;
            --hks-btn-padding-x: 1.5rem;
            --hks-btn-font-size: 1rem;
            --hks-btn-border-radius: 0;
            --hks-btn-offset: 0.05em;

            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.75em;
            padding-top: calc(var(--hks-btn-padding-y) - var(--hks-btn-offset));
            padding-right: var(--hks-btn-padding-x);
            padding-bottom: calc(var(--hks-btn-padding-y) + var(--hks-btn-offset));
            padding-left: var(--hks-btn-padding-x);
            font-size: var(--hks-btn-font-size);
            font-weight: 700;
            line-height: 1.5;
            color: #fff;
            text-align: center;
            text-decoration: none;
            vertical-align: middle;
            cursor: pointer;
            user-select: none;
            border: 1px solid var(--hks-secondary, #882345);
            border-radius: var(--hks-btn-border-radius);
            background-color: var(--hks-secondary, #882345);
            transition:
                color 0.15s ease-in-out,
                background-color 0.15s ease-in-out,
                border-color 0.15s ease-in-out,
                transform 0.1s ease-in-out;
        }
        .css-18s6wo4:hover {
            color: #fff;
            text-decoration: none;
            border-color: #c50059;
            background-color: #c50059;
        }
        .css-18s6wo4:focus-visible {
            outline: 2px solid var(--hks-focus-ring-color, #003064);
            outline-offset: 2px;
            box-shadow: none;
        }
        .css-18s6wo4:active {
            transform: scale(0.98);
        }
        .css-18s6wo4[disabled],
        .css-18s6wo4[aria-disabled="true"] {
            opacity: 0.65;
            pointer-events: none;
        }
        .css-1o5zwgz {
            margin-top: 2rem !important;
        }
        #stage-fullscreen-root, #stage-widget-root {
            .swiper-pagination-bullets {
                background-color: rgb(216.75, 223.95, 231.75) !important;
            }
        }
        #stage-fullscreen-root, #stage-widget-root {
            .swiper-pagination-bullet::after {
                content: "";
                position: absolute;
                z-index: 100;
                inset: 0;
                height: 8px;
                width: 8px;
                border-radius: 50%;
                margin: auto;
                background-color: var(--hks-heading-color);
            }
        }
        .css-1wuxw35 {
            border-radius: 0;
        }
        .css-12aytpw {
            background-color: var(--hks-secondary);
            border: none;
            color: inherit;
            cursor: pointer;
            flex-shrink: 0;
            align-self: center;
            padding: 0px;
            width: auto;
            height: auto;
            margin: 0.5rem;
            padding: .5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            svg {
                color: #fff;
            }
        }
        .css-12aytpw:focus-visible {
            outline: 2px solid var(--hks-primary, #003064);
            outline-offset: 2px;
        }
        .css-12aytpw:hover {
            background-color: var(--hks-secondary-rosenrot);
            svg {
                color: #fff;
            }
        }
        @media (max-width: 600px) {
            .css-12aytpw {
                display: none;
            }
        }

        @media (min-width: 1800px) {
            .css-ov1ktg {
            gap: 1rem;
            }
        }

        .swiper-slide:last-child {
            display: none !important;
        }

    `;
}

function injectStyleIntoShadowRoot(shadowRoot) {
    if (shadowRoot.getElementById(STYLE_ID)) {
        return false;
    }

    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = getStyleMarkup();
    shadowRoot.appendChild(style);

    return true;
}

function styleStageWidgetHost(host) {
    if (!(host instanceof HTMLElement) || !host.shadowRoot) {
        return false;
    }

    return injectStyleIntoShadowRoot(host.shadowRoot);
}

function styleAllStageWidgets() {
    const hosts = document.querySelectorAll(HOST_SELECTOR);
    let hasInjected = false;

    hosts.forEach((host) => {
        if (styleStageWidgetHost(host)) {
            hasInjected = true;
        }
    });

    return hasInjected;
}

export function initStageWidgetShadowStyling() {
    if (!document.querySelector(HOST_SELECTOR)) {
        return;
    }

    let attempts = 0;

    const observer = new MutationObserver(() => {
        if (styleAllStageWidgets()) {
            log('Shadow style injected for "stage-widget"');
        }
    });

    const intervalId = window.setInterval(() => {
        attempts += 1;

        if (styleAllStageWidgets()) {
            log('Shadow style injected for "stage-widget"');
        }

        if (attempts >= MAX_ATTEMPTS) {
            window.clearInterval(intervalId);
            observer.disconnect();
            log("Stopped stage-widget shadow style watcher", "warn");
        }
    }, INTERVAL_MS);

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial attempt directly on init
    styleAllStageWidgets();
}
